import { render, staticRenderFns } from "./EnterAccountDetails.vue?vue&type=template&id=5f2cd340&scoped=true"
import script from "./EnterAccountDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./EnterAccountDetails.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EnterAccountDetails.vue?vue&type=style&index=0&id=5f2cd340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2cd340",
  null
  
)

export default component.exports